import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { FOLLOW_REPLY_CHANNEL } from 'apps/followReply/constants'
import { FollowReplyState } from 'apps/followReply/interfaces'
import { getChannelState, NAMESPACE } from 'apps/followReply/store/constants'
import { followReplyApi } from 'shared/api/requests/followReply'
import { createAsyncAction } from 'shared/lib/redux'

export const loadFlow = createAsyncAction(`${NAMESPACE}/loadFlow`, async () => {
  const flowData = await followReplyApi.getData()

  return flowData.data
})

export const loadFlowReducer = (builder: ActionReducerMapBuilder<FollowReplyState>) => {
  builder.addCase(loadFlow.pending, (state) => {
    state[FOLLOW_REPLY_CHANNEL].fetching = true
  })
  builder.addCase(loadFlow.fulfilled, (state, action) => {
    const data = action.payload
    state[FOLLOW_REPLY_CHANNEL] = getChannelState(data)
  })
  builder.addCase(loadFlow.rejected, (state) => {
    state[FOLLOW_REPLY_CHANNEL].fetching = false
  })
}
